export const SET_USERINFO = 'SET_USERINFO'
export const SET_LOGIN_STATUS = 'SET_LOGIN_STATUS'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_LOADING = 'SET_LOADING'
export const SET_PHONECODE = 'SET_PHONECODE'
export const SET_PHONENUM = 'SET_PHONENUM'
export const SET_TABINDEX = 'SET_TABINDEX'
export const SET_ARTICLE_SNAPSHOT = 'SET_ARTICLE_SNAPSHOT'
export const SET_TABSHOW = 'SET_TABSHOW'
export const UPDATE_PROCESS = 'UPDATE_PROCESS'
export const SET_START_TIMESTAMP = 'SET_START_TIMESTAMP'
export const SWTICH_ARTICLE_LEVEL = 'SWTICH_ARTICLE_LEVEL'
export const SELECT_ARTICLE_CONTENT = 'SELECT_ARTICLE_CONTENT'
export const SET_ARTICLE_DETAIL = 'SET_ARTICLE_DETAIL'
export const GET_ARTICLE_LEVELS = 'GET_ARTICLE_DETAIL'
export const SET_PRIMARY_WORD = "SET_PRIMARY_WORD"
export const SET_ARTICLE_CONTENT = "SET_ARTICLE_CONTENT"
export const UPDATE_WORD_BOOK = "UPDATE_WORD_BOOK"
export const SET_ARTICLE_QUIZ = "SET_ARTICLE_QUIZ"
export const UPDATE_ARTICLE_ANSWER = "UPDATE_ARTICLE_ANSWER"
export const SET_ARTICLE_RESULT = "SET_ARTICLE_RESULT"
export const RESET_ARTICLE = "RESET_ARTICLE"




//////////////////
// WEBPACK FOOTER
// ./app/store/mutation-types.js
// module id = null
// module chunks = 